/**
 * @flow
 */

import { fromJS } from 'immutable';
import { FETCH_LISTING_PENDING, FETCH_LISTING_SUCCESS, FETCH_LISTING_FAILURE, UPDATE_EVENT_PENDING, UPDATE_EVENT_SUCCESS } from './actions';

const initialState = {};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case FETCH_LISTING_SUCCESS:
      return fromJS({
        fetching: false,
        failed: false,
        data: action.data
      });

    case FETCH_LISTING_FAILURE:
      return fromJS({
        fetching: false,
        failed: true,
        data: null
      });

    case FETCH_LISTING_PENDING:
      return fromJS({
        fetching: true,
        failed: false,
        data: null
      });

    case UPDATE_EVENT_PENDING:
      const updated = { listing: Object.assign(state.getIn(['data', 'listing']).toJS(), action.changes) };
      return fromJS({
        fetching: false,
        failed: false,
        data: Object.assign(state.get('data').toJS(), updated)
      });

    case UPDATE_EVENT_SUCCESS:
      return fromJS({
        fetching: false,
        failed: false,
        data: action.data
      });

    default:
      return fromJS(state);
  }
};



// WEBPACK FOOTER //
// ./src/modules/listing/reducer.js